export const STORE_PERIOD_SINGLE = 'boilerplate/GSTR1NEWCOMMON/STORE_PERIOD_SINGLE';
export const STORE_PERIOD = 'boilerplate/GSTR1NEWCOMMON/STORE_PERIOD';
export function setPeriodStore(startDate, endDate){
  return{
    type: STORE_PERIOD,
    date: {startDate, endDate}
  }
};
export function setPeriodStoreSingle(period){
  return{
    type: STORE_PERIOD_SINGLE,
    date: period
  }
}